import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/layouts/default.vue").then(m => m.default || m))
}